import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Modal } from '@material-ui/core';
import './index.css';
import axios from 'axios';
import Block from './Card';
import perrito from '../../Assets/Imagenes/perrito.svg';
import { connect } from 'react-redux';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { propsType, reduxAction, response } from '../../Types/petType';
import swal from 'sweetalert';

function mapStateToProps(state: reduxAction) {
  return { action: state };
}

const IndexUserPets: FC<propsType> = (props): ReactElement => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [petParams, setPetParams] = useState<Array<response>>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cotutors, setCotutors] = useState<Array<{ id: string, name: string, rut: string, email: string }>>([]);

  useEffect(() => {
    const fetchUserPets = async () => {
      const token = JSON.parse(localStorage.getItem('token') || '');
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/userPets/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setPetParams(res.data.pets);
      } catch (err) {
        console.error('Error fetching pets:', err);
      }
    };
    fetchUserPets();
  }, [id]);

  async function getCotutors(petId: string) {
    const token = JSON.parse(localStorage.getItem('token') || '');
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL}/userPets/subtutor?petId=${petId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return res.data.cotutors;
    } catch (err) {
      console.error('Error fetching cotutors:', err);
      return [];
    }
  }

  const handleViewCotutors = async (petId: string) => {
    const results = await getCotutors(petId);
    setCotutors(results);
    setIsModalOpen(true);
  };

  const handleViewProfile = (cotutor: { id: string, name: string, rut: string, email: string }) => {
    console.log('Perfil del cotutor:', cotutor);
    navigate(`/users/${cotutor.id}`);
  };

  const addPatient = (petId: string) => {
    const token = JSON.parse(localStorage.getItem('token') || '');
    axios
      .post(`${process.env.REACT_APP_URL}/headVets/${petId}/${props.action.user.credenciales.id}`,
        { create: true },
        { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        swal({
          title: 'Mascota agregada con éxito',
          icon: 'success',
          buttons: { Aceptar: true },
          timer: 2000
        });
      })
      .catch(() => {
        swal({
          title: 'Error',
          text: 'Esta mascota ya es tu paciente',
          icon: 'error',
          buttons: { Aceptar: true },
          timer: 2000
        });
      });
  };

  const volver = () => {
    navigate(-1);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className='wrapper'>
        <Navbar logged={true} />
        <div className='spacer32' />
        <h6 className='navigation-info-post-post ms-3'>Mascotas</h6>
        <div className='spacer-20' />
        <div className='row' style={{ display: 'flex', margin: '0px 20px', alignItems: 'center', padding: '0px', justifyContent: 'space-between' }}>
          {petParams.length > 0 ? (
            petParams.map((estado) => (
              <div key={estado.petId} className='row' style={{ display: 'flex', margin: '0px 20px', alignItems: 'center', padding: '0px', justifyContent: 'space-between' }}>
                <div className='col-8 m-auto'>
                  <Block
                    id={estado.petId}
                    state={estado}
                    navigate={navigate}
                    location={location}
                    token={props.action.user.credenciales.token}
                    id_actual_user={props.action.user.credenciales.id}
                  />
                </div>
                {props.action.user.credenciales.rol === 2 && (
                  <div className='col-3' style={{ margin: '0px' }}>
                    <button
                      className='button-index-user-pets'
                      role='button'
                      aria-pressed='true'
                      onClick={() => addPatient(estado.petId)}
                    >
                      Agregar Paciente
                    </button>
                    <button
                      className='button-index-user-pets'
                      role='button'
                      aria-pressed='true'
                      onClick={() => handleViewCotutors(estado.petId)}
                      style={{ marginLeft: '10px' }}
                    >
                      Ver Co-tutores
                    </button>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className='card-masc container-mascotas-vacio'>
                <div className='title-pets'>Este usuario no posee mascotas</div>
                <div className='imagen-vet'>
                  <img src={perrito} alt='new' style={{ borderRadius: '10px', maxWidth: '100px', maxHeight: '100px' }} />
                </div>
              </div>
            </div>
          )}
        </div>

        <Modal open={isModalOpen} onClose={closeModal}>
          <div className='modal-content'>
            <h2>Co-tutores</h2>

            {cotutors.length > 0 ? (
              <table className="cotutors-table">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>RUT</th>
                    <th>Email</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {cotutors.map((cotutor, index) => (
                    <tr key={index}>
                      <td>{cotutor.name}</td>
                      <td>{cotutor.rut}</td>
                      <td>{cotutor.email}</td>
                      <td>
                        <button className="perfil-btn" onClick={() => handleViewProfile(cotutor)}>
                          Ver Perfil
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No hay co tutores disponibles.</p>
            )}

            <button onClick={closeModal} className="modal-close-btn">
              Cerrar
            </button>
          </div>
        </Modal>

        <div className='spacer-12' />
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <button className='link-back-mascotas-showAll' role='button' aria-pressed='true' onClick={volver}>
            Volver
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default connect(mapStateToProps)(IndexUserPets);
